import { mapGetters } from 'vuex'

export const authorizationComputed = {
    ...mapGetters(['hasRole'])
}
